import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectToDocumentsPage = () => {
  const { navigation } = useNavigation()

  return <Navigate replace to={navigation.documents.list.fullPath()} />
}

export default RedirectToDocumentsPage
